import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { testimonials } from "@/mocks/articles";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "关于吃瓜网 - 全网最全黑料第一站",
  "description": "吃瓜网是全网领先的实时吃瓜爆料平台，汇聚每日大赛、独家八卦、网红大瓜。致力于为用户提供最新最全的娱乐八卦和正能量内容。",
  "url": "http://claekqe.cn/about",
  "isPartOf": {
    "@type": "WebSite",
    "name": "吃瓜网",
    "url": "http://claekqe.cn/"
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "吃瓜网的内容来源是什么？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "吃瓜网拥有专业的编辑和调查团队，内容来源包括自主采编、网友投稿、公开信息整理以及合作媒体供稿。所有内容发布前均经过严格的真实性审核流程，确保为用户提供可靠的吃瓜内容。"
      }
    },
    {
      "@type": "Question",
      "name": "如何与吃瓜网进行商务合作？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "欢迎通过以下方式联系我们洽谈商务合作：邮箱 hello@claekqe.cn，电话 400-888-6666。我们的商务团队将在收到您的信息后24小时内与您联系。"
      }
    },
    {
      "@type": "Question",
      "name": "吃瓜网接受用户投稿吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "当然！吃瓜网欢迎广大网友投稿爆料。请将您的爆料内容发送至投稿邮箱 hello@claekqe.cn。我们承诺对投稿人信息严格保密，经核实的内容将优先发布并标注来源。"
      }
    }
  ]
};

const services = [
  { name: "每日大赛", description: "精选当日最热吃瓜内容，每日更新" },
  { name: "独家爆料", description: "深度调查，第一手内幕消息" },
  { name: "实时追踪", description: "24小时热点事件实时跟进" },
  { name: "分类导航", description: "六大频道全面覆盖吃瓜需求" },
  { name: "网友投稿", description: "开放平台，人人都是爆料人" },
  { name: "正能量", description: "不止八卦，更有温暖与感动" },
];

const serviceImages = [
  "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20concept%20with%20abstract%20warm%20geometric%20shapes%2C%20clean%20minimal%20design%2C%20soft%20gradient%20background%2C%20news%20and%20media%20theme%2C%20editorial%20aesthetic%2C%20daily%20headlines&width=500&height=350&seq=about-service-0&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20concept%20with%20abstract%20warm%20geometric%20shapes%2C%20clean%20minimal%20design%2C%20soft%20gradient%20background%2C%20investigative%20journalism%20theme%2C%20exclusive%20scoop%20concept&width=500&height=350&seq=about-service-1&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20concept%20with%20abstract%20warm%20geometric%20shapes%2C%20clean%20minimal%20design%2C%20soft%20gradient%20background%2C%20real%20time%20tracking%20theme%2C%20live%20update%20concept&width=500&height=350&seq=about-service-2&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20concept%20with%20abstract%20warm%20geometric%20shapes%2C%20clean%20minimal%20design%2C%20soft%20gradient%20background%2C%20category%20navigation%20theme%2C%20organized%20content&width=500&height=350&seq=about-service-3&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20concept%20with%20abstract%20warm%20geometric%20shapes%2C%20clean%20minimal%20design%2C%20soft%20gradient%20background%2C%20user%20submission%20theme%2C%20community%20engagement&width=500&height=350&seq=about-service-4&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20concept%20with%20abstract%20warm%20geometric%20shapes%2C%20clean%20minimal%20design%2C%20soft%20gradient%20background%2C%20positive%20energy%20theme%2C%20warm%20hopeful%20vibe&width=500&height=350&seq=about-service-5&orientation=landscape",
];

export default function About() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(aboutSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      <Header />
      <main>
        <section className="relative bg-gradient-to-b from-background-800 to-background-900 pt-24 pb-20 md:pt-32 md:pb-28 px-4 md:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: "首页", href: "/" },
                  { label: "关于我们" },
                ]}
              />
            </div>

            <div className="mb-4">
              <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 text-white/90 text-sm font-medium">
                关于 / 吃瓜网
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight max-w-3xl">
              全网最全黑料第一站
            </h1>

            <p className="text-white/65 text-base md:text-lg leading-relaxed max-w-3xl mb-16">
              吃瓜网成立于2023年，是国内领先的实时吃瓜爆料平台。我们致力于汇聚全网最热门的娱乐八卦、网红黑料和社会热点，以最快的速度、最全的视角、最真实的态度，为广大吃瓜群众提供一站式的吃瓜体验。
            </p>

            <div className="flex flex-col md:flex-row items-start gap-10 md:gap-20">
              <div className="w-full md:w-2/5">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20media%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20warm%20ambient%20lighting%2C%20professional%20workspace%2C%20digital%20news%20platform%20concept%2C%20clean%20modern%20design%2C%20editorial%20environment&width=600&height=500&seq=about-brand&orientation=landscape"
                  alt="吃瓜网品牌形象"
                  className="w-full rounded-2xl object-cover"
                />
              </div>
              <div className="w-full md:w-3/5">
                <span className="font-heading text-7xl md:text-8xl lg:text-9xl font-black text-white/10 leading-none">
                  24H
                </span>
                <p className="text-white/50 text-lg mt-2 mb-6">全天候不间断更新</p>
                <p className="text-white/70 text-sm md:text-base leading-relaxed">
                  我们的编辑团队覆盖全国主要城市，全天候追踪热点事件。无论是凌晨突发的娱乐圈大瓜，还是深夜流出的网红黑料，吃瓜网都能第一时间为你呈现。全年无休，吃瓜不停。
                </p>
                <a
                  href="mailto:hello@claekqe.cn"
                  className="mt-6 inline-flex items-center gap-2 px-8 py-3 bg-white text-foreground-950 font-medium rounded-full hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap text-sm"
                >
                  联系合作
                  <i className="ri-mail-send-line"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 px-4 md:px-6 lg:px-8 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
              <div className="md:w-3/5">
                <span className="text-foreground-400 text-xs font-medium tracking-wider mb-2 inline-block">
                  &bull; 主编寄语
                </span>
                <blockquote className="font-heading text-2xl md:text-4xl text-foreground-950 leading-relaxed">
                  <span className="text-foreground-300 text-5xl md:text-7xl">&ldquo;</span>
                  <br />
                  吃瓜不是目的，真相才是。在这个信息爆炸的时代，我们坚持做有态度的吃瓜平台——不造谣、不传谣、用事实说话。每一篇爆料背后，都是编辑团队对真相的执着追求。吃瓜网，让每一次吃瓜都有价值。
                </blockquote>
                <div className="flex items-center gap-3 mt-6">
                  <span className="font-heading font-bold text-foreground-950">老瓜</span>
                  <span className="flex items-center gap-1 text-accent-500 text-xs">
                    <i className="ri-verified-badge-fill"></i>
                    <span className="text-foreground-500">吃瓜网创始人 & 主编</span>
                  </span>
                </div>
              </div>
              <div className="md:w-2/5">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20editor%20portrait%20black%20and%20white%20photography%2C%20side%20profile%2C%20contemplative%20expression%2C%20clean%20white%20background%2C%20artistic%20portrait%2C%20fine%20art%20style%2C%20editorial%20quality&width=500&height=650&seq=founder-portrait&orientation=portrait"
                  alt="吃瓜网创始人"
                  className="w-full max-w-xs mx-auto rounded-2xl object-cover aspect-[3/4]"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12 md:mb-16">
              <div className="lg:w-2/5">
                <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 tracking-tight leading-tight">
                  我们的
                  <br />
                  业务矩阵
                </h2>
              </div>
              <div className="lg:w-3/5">
                <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
                  六大核心服务，全面覆盖你的吃瓜需求。从每日精选到独家深度调查，吃瓜网为您提供全方位的内容服务。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="relative rounded-2xl overflow-hidden aspect-[3/4] md:row-span-2 md:aspect-auto bg-background-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20newsroom%20bureau%20with%20vintage%20typewriter%20and%20modern%20computer%2C%20warm%20spotlight%2C%20investigative%20journalism%20concept%2C%20film%20noir%20aesthetic%2C%20mysterious%20atmosphere&width=800&height=1200&seq=about-services-big&orientation=portrait"
                  alt="吃瓜网业务矩阵"
                  className="absolute inset-0 w-full h-full object-cover opacity-60"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/90 via-background-900/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-heading text-2xl md:text-3xl font-black text-white mb-2">核心数据</h3>
                  <p className="text-white/70 text-sm">日均访问量超过500万，月活跃用户3000万+，累计发布独家爆料超3万篇</p>
                </div>
              </div>

              {services.map((service, i) => (
                <div
                  key={service.name}
                  className="rounded-2xl p-6 bg-background-50"
                >
                  <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium mb-4 ${
                    i === 0 ? "bg-primary-100 text-primary-700" :
                    i === 1 ? "bg-accent-100 text-accent-700" :
                    i === 2 ? "bg-secondary-100 text-secondary-700" :
                    i === 3 ? "bg-primary-100 text-primary-700" :
                    i === 4 ? "bg-accent-100 text-accent-700" :
                    "bg-secondary-100 text-secondary-700"
                  }`}>
                    <i className="ri-check-line"></i>
                    服务
                  </span>
                  <img
                    src={serviceImages[i]}
                    alt={service.name}
                    className="w-full rounded-xl object-cover aspect-[16/10] mb-4"
                  />
                  <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">{service.name}</h3>
                  <p className="text-foreground-500 text-xs md:text-sm">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="mb-12 md:mb-16">
              <div className="flex items-center gap-3 mb-3">
                <span className="w-1.5 h-5 bg-accent-500 rounded-full"></span>
                <span className="text-accent-600 text-sm font-medium tracking-wider">TESTIMONIALS</span>
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 tracking-tight">
                用户口碑
              </h2>
              <p className="mt-3 text-foreground-500 text-sm md:text-base">
                来自真实用户的声音
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-100 rounded-2xl p-6 md:p-8">
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-11 h-11 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-medium text-foreground-950 text-sm">{t.name}</p>
                      <p className="text-foreground-400 text-xs">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 md:py-32 px-4 md:px-6 lg:px-8 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-12 md:mb-16 rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20contact%20us%20concept%20with%20vintage%20telephone%20and%20modern%20smartphone%2C%20warm%20orange%20lighting%2C%20newsroom%20background%2C%20communication%20theme%2C%20professional%20yet%20warm%20atmosphere&width=1200&height=600&seq=about-cta-banner&orientation=landscape"
                alt="联系我们"
                className="w-full object-cover"
              />
            </div>
            <p className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-relaxed tracking-tight max-w-3xl mx-auto">
              有<span className="italic text-foreground-400 font-light">猛料</span>想爆？
              <br />
              加入吃瓜网<span className="font-black">大家庭</span>
              <br />
              一起<span className="italic text-foreground-400 font-light">创造</span>最热吃瓜内容
            </p>

            <div className="mt-10 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:hello@claekqe.cn"
                className="inline-flex items-center gap-2 px-10 py-4 bg-foreground-950 text-background-50 font-medium rounded-full hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                投稿爆料
                <i className="ri-send-plane-line"></i>
              </a>
              <span className="text-foreground-400 text-sm">或拨打 400-888-6666</span>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 text-center mb-12 md:mb-16">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-8 rounded-2xl bg-background-100">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 mb-2">投稿邮箱</h3>
                <p className="text-foreground-500 text-sm">hello@claekqe.cn</p>
              </div>
              <div className="text-center p-8 rounded-2xl bg-background-100">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-phone-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 mb-2">客服电话</h3>
                <p className="text-foreground-500 text-sm">400-888-6666</p>
              </div>
              <div className="text-center p-8 rounded-2xl bg-background-100">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-map-pin-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 mb-2">公司地址</h3>
                <p className="text-foreground-500 text-sm">北京市朝阳区传媒大厦18层</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}